/* Section: Locations — section#locations (#locAccordion, .loc-image-panel, .copy-address-btn)
 *
 * The "Locations: one-open accordion" IIFE from the adensalt.com custom-code block
 * (section-scripts-a.js), unchanged. It includes the copy-address buttons. The original
 * file wrapped all of its IIFEs in one strict-mode closure; the outer wrapper below
 * reproduces that so the code runs under the same semantics. No endpoints involved.
 * The script is enqueued in the footer, so #locAccordion exists when this runs.
 */
(function(){
  "use strict";
  /* ---------- Locations: one-open accordion ---------- */
  (function(){
    /* Exactly one row open (Tomkins Cove Marine Terminal by default); the photo crossfades to the open yard.
       Opens on click, keyboard focus, Enter/Space (native button), and on hover with a 120ms intent
       delay on wide fine-pointer screens. Hover only reacts to real pointer movement, so rows sliding
       under a still cursor while a row expands never flip the open row. Leaving the list keeps the
       last open row. Taps on the open row keep it open. */
    var acc = document.getElementById('locAccordion');
    if(!acc) return;
    var items = Array.prototype.slice.call(acc.querySelectorAll('.loc-item'));
    var imgs = Array.prototype.slice.call(document.querySelectorAll('.loc-image-panel .loc-img'));
    var activeIndex = 0;
    function setDetailInert(item, off){
      var d = item.querySelector('.loc-detail');
      if(!d) return;
      d.inert = off;
      if(off) d.setAttribute('inert', ''); else d.removeAttribute('inert');
    }
    function setLocActive(idx){
      idx = Math.max(0, Math.min(items.length - 1, idx));
      activeIndex = idx;
      items.forEach(function(el, i){
        var on = i === idx;
        el.classList.toggle('is-active', on);
        var btn = el.querySelector('.loc-item-name-btn');
        if(btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        setDetailInert(el, !on);
      });
      /* a yard without its own picture keeps the current one */
      if(imgs[idx]) imgs.forEach(function(el, i){ el.classList.toggle('is-active', i === idx); });
    }
    setLocActive(0);
    items.forEach(function(el, i){
      var btn = el.querySelector('.loc-item-name-btn');
      if(!btn) return;
      btn.addEventListener('click', function(){ if(i !== activeIndex) setLocActive(i); });
      btn.addEventListener('focus', function(){ if(i !== activeIndex) setLocActive(i); });
    });
    var hoverMq = window.matchMedia ? window.matchMedia('(min-width:1024px) and (hover:hover) and (pointer:fine)') : null;
    var timer = null, pending = -1, lastX = null, lastY = null;
    function clearIntent(){ if(timer){ clearTimeout(timer); timer = null; } pending = -1; }
    acc.addEventListener('pointermove', function(e){
      if(e.pointerType !== 'mouse' || !hoverMq || !hoverMq.matches) return;
      if(e.clientX === lastX && e.clientY === lastY) return;
      lastX = e.clientX; lastY = e.clientY;
      var row = e.target.closest ? e.target.closest('.loc-item') : null;
      var idx = row ? items.indexOf(row) : -1;
      if(idx < 0 || idx === activeIndex){ clearIntent(); return; }
      if(idx === pending) return;
      clearIntent();
      pending = idx;
      timer = setTimeout(function(){
        timer = null;
        var under = document.elementFromPoint(lastX, lastY);
        var still = under && under.closest ? under.closest('.loc-item') : null;
        if(still === items[pending]) setLocActive(pending);
        pending = -1;
      }, 120);
    });
    acc.addEventListener('pointerleave', function(){ clearIntent(); lastX = lastY = null; });
    /* ---------- Copy address buttons ---------- */
    document.querySelectorAll('.copy-address-btn').forEach(function(btn){
      var original = btn.textContent;
      btn.addEventListener('click', function(){
        var addr = btn.getAttribute('data-address') || '';
        var done = function(){
          btn.textContent = 'Copied';
          setTimeout(function(){ btn.textContent = original; }, 1500);
        };
        /* Theme addition: navigator.clipboard only exists in a secure context, so on the
           plain-HTTP review build the original silently did nothing. Fall back to a
           selection copy there; over HTTPS the original path runs unchanged. */
        var legacyCopy = function(){
          var ta = document.createElement('textarea'), ok = false;
          ta.value = addr; ta.setAttribute('readonly', ''); ta.setAttribute('aria-hidden', 'true');
          ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          try { ok = document.execCommand('copy'); } catch(e){ ok = false; }
          document.body.removeChild(ta);
          try { btn.focus({preventScroll:true}); } catch(e){ btn.focus(); }
          if(ok) done();
          return ok;
        };
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(addr).then(done).catch(function(err){ if(!legacyCopy()) console.error('Copy failed', err); });
        } else if(!legacyCopy()){
          console.error('Copy failed: clipboard unavailable');
        }
      });
    });
  })();
})();
